import React from 'react';
import { motion } from 'framer-motion';

export default function Impact() {
  const stats = [
    { value: "2.4M+", label: "Plastic Bottles Diverted" },
    { value: "450k", label: "Gallons of Water Saved" },
    { value: "100%", label: "Carbon Neutral Logistics" }
  ];

  return (
    <section id="impact" className="py-24 md:py-32 bg-[var(--kraft)] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="order-2 lg:order-1">
            <div className="inline-block px-3 py-1 mb-6 rounded-full bg-[var(--navy)] text-[var(--mint)] text-[10px] font-bold tracking-widest uppercase">
              Measurable Change
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-[var(--navy)] mb-8 leading-[1.1] italic">
              Our Circular <br/>Commitment.
            </h2>
            <p className="text-lg md:text-xl text-[var(--navy-light)] mb-12 leading-relaxed opacity-80">
              The traditional home care industry is built on a model of shipping water in single-use plastic. We've inverted that. By shipping active concentrates in compostable paper, we reduce the carbon footprint of every load by up to 90%.
            </p>
            <div className="grid sm:grid-cols-3 gap-8 md:gap-12">
              {stats.map((stat, idx) => (
                <motion.div 
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                  className="group"
                >
                  <div className="text-4xl md:text-5xl font-bold text-[var(--navy)] mb-2 group-hover:text-[var(--mint-dark)] transition-colors">{stat.value}</div>
                  <div className="text-[10px] font-bold uppercase tracking-widest text-[var(--navy-light)] opacity-60 leading-tight">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </div>
          
          <div className="relative order-1 lg:order-2 h-[500px] lg:h-[700px] rounded-3xl overflow-hidden shadow-2xl group">
            {/* Updated context image: Reusable/Circular Packaging */}
            <picture>
              <source 
                srcSet="https://images.unsplash.com/photo-1605600611284-1b21b7a0a6b0?auto=format&fit=crop&q=85&w=800 800w, https://images.unsplash.com/photo-1605600611284-1b21b7a0a6b0?auto=format&fit=crop&q=85&w=1200 1200w" 
                sizes="(max-width: 1024px) 100vw, 50vw" 
                type="image/webp" 
              />
              <img 
                src="https://images.unsplash.com/photo-1605600611284-1b21b7a0a6b0?auto=format&fit=crop&q=80&w=1200" 
                alt="Eco-friendly recycled cardboard shipping box with natural packing materials" 
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                width="600"
                height="800"
                loading="lazy"
                decoding="async"
              />
            </picture>
            <div className="absolute inset-0 bg-[var(--navy)]/10 mix-blend-multiply group-hover:bg-[var(--navy)]/0 transition-all duration-700"></div>
            
            <div className="absolute bottom-8 left-8 right-8 bg-white/90 backdrop-blur-md p-6 rounded-xl border border-white/20">
              <p className="text-sm font-medium text-[var(--navy)] italic">
                "We don't just sell products; we manage a circular infrastructure for the modern home."
              </p>
              <p className="text-[10px] font-bold uppercase tracking-widest text-gray-500 mt-2">CleanNest Founders</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}